<template lang="pug">
    #chat-window.fill-height
        v-layout(v-if="currentRoomIsEmpty" column fill-height justify-center align-center).grey--text
            v-icon(size="150" color="grey") {{icons.chat}}
            .headline.font-weight-light Please Select Channel
            .headline.font-weight-light For Start Communication :)
        v-layout(column v-else)
            v-app-bar(color="transparent" dense :flat="true" light height="60" v-if="!forOperatingSheet")
                v-menu(offset-y v-if="canEditRoom && !currentRoom.completed_at")
                    template(#activator="{ on }")
                        v-btn(icon v-on="on")
                            v-icon mdi-dots-vertical
                    v-list(dense)
                        v-list-item(@click="onEditRoom")
                            v-list-item-icon
                                v-icon mdi-pencil-outline
                            v-list-item-title Chat Room Setting
                        v-list-item(@click="onCompleteCase")
                            v-list-item-icon
                                v-icon mdi-checkbox-marked-circle-outline
                            v-list-item-title Complete Case
                v-spacer
                v-toolbar-title(v-if="false").font-weight-medium {{currentRoomId ? `${currentRoom.title} [${currentRoom.id}]` : ""}}
                v-toolbar-title(v-if="true").font-weight-medium {{currentRoomId ? currentRoom.title : ''}}
                v-spacer
                template(v-if="currentRoom && (currentRoom.type === 'file' || currentRoom.type === 'sheet')")
                    v-btn(v-if="$vuetify.breakpoint.smAndDown" rounded color="primary" @click="onClickOpenFileOrSheet")
                        v-icon {{currentRoom.type === 'file' ? 'mdi-folder' : 'mdi-table-large'}}
                    v-btn(v-else rounded color="primary" @click="onClickOpenFileOrSheet" )
                        v-icon(left) {{currentRoom.type === 'file' ? 'mdi-folder' : 'mdi-table-large'}}
                        span {{currentRoom.type === 'file' ? $t("pages.chat.openFolder") : $t("pages.chat.openSheet")}}
            v-card(flat color="white" v-chat-scroll="{always: true, smooth: true, scrollonremoved: true}").chat-window
                v-layout(tag="v-card-text" column mx-auto)
                    template(v-for="(chat, index) in conversations")
                        v-timeline(dense align-top :reverse="chat.me" :key="chat.id")
                            v-timeline-item(:hide-dot="false && (index > 0) && (conversations[index - 1].sender.id === chat.sender.id)"
                                icon-color="transparent"
                                :class="{'chat-bubble__right': chat.me}").chat-bubble
                                template(#icon)
                                    v-avatar.elevation-3
                                        img(:src="chat.sender.avatar")
                                .caption.mb-1(v-if="!chat.me" style="max-width: 180px").text-truncate {{chat.sender.name}}
                                template(v-if="chat.content_type === 'msg'")
                                    v-card(:color="chat.me ? 'header lighten-1' : 'grey lighten-3'").chat-bubble__card
                                        v-card-text(style="white-space: pre-line;").black--text
                                            .subtitle-1(:class="{'text-right': false && chat.me}" v-html="parseContent(chat)")
                                template(v-else)
                                    v-card(:color="chat.me ? 'header lighten-1' : 'grey lighten-3'" max-width=200 @click="onClickImage(chat)").pa-2.chat-bubble__card
                                        v-img(:src="chat.content" contain max-width=200
                                            lazy-src="https://picsum.photos/id/11/100/60")
                                            template(#placeholder)
                                                v-layout(fill-height align-center justify-center ma-0)
                                                    v-progress-circular(indeterminate color='grey lighten-5')
                                .caption.mt-1(style="max-width: 180px;" :class="{'text-right chat-bubble__right': chat.me}").text-truncate {{chat.sent_at | dateTimeFormat}}
            div(style="background: transparent").pa-3.column.layout
                v-layout
                    v-flex(grow)
                        v-textarea(:value="message" @input='onChangeMessage' :placeholder='$t("general.chatBoxPlaceHolder")' @keydown="onKeyDown"
                            outlined no-resize hide-details rows=4 :rounded="false")
                    v-layout(shrink flex column).py-0.px-2
                        input(ref="file" type="file" accept="image/*" @change="onFilePicked" style="display: none;")
                        v-tooltip(top)
                            template(v-slot:activator="{ on }")
                                v-btn(icon @click.stop="onClickSend" v-on="on" :disabled="messageSending || !message || !(message.trim())")
                                    v-icon mdi-send
                            span Send message
                        v-tooltip(top)
                            template(#activator="{on}")
                                v-btn(icon @click.stop="onMention" v-on="on" :disabled="messageSending")
                                    v-badge(color='badge' :overlap="true" right bottom)
                                        template(v-slot:badge)
                                            span(v-if="mentionCount > 0").caption.font-weight-bold {{mentionCount}}
                                        v-icon mdi-voice
                            span(v-if="!!mentionCount" v-html="mentionHtml")
                            span(v-else) Mention
                        v-tooltip(top)
                            template(v-slot:activator="{ on }")
                                v-btn(icon @click.stop="onPickFile" :loading="imageUploading" v-on="on" :disabled="messageSending")
                                    v-icon mdi-image-outline
                            span Take a picture
</template>

<script>
import isEmpty from "lodash/isEmpty";
import trim from "lodash/trim";
import general from "../../mixins/general";
import { newMessageMapped } from "../../util/chat.js";
import crud from "../../mixins/crud";

export default {
  name: "ChatWindow",
  mixins: [general, crud],
  props: {
    socketId: {
      default: null
    },
    message: {
      required: true
    },
    currentRoom: {
      type: Object,
      default: () => ({})
    },
    conversations: {
      type: Array,
      default: () => []
    },
    currentRoomId: {
      type: Number,
      default: 0
    },

    // For Operating Sheet
    forOperatingSheet: {
      type: Boolean,
      default: false
    },
    canEditRoom: Boolean,
    mentionCount: Number,
    mentionHtml: String,
    mentionIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      imageUploading: false,
      cancelUpload: null,
      messageSending: false
    };
  },
  computed: {
    currentRoomIsEmpty() {
      return !this.currentRoomId || isEmpty(this.currentRoom);
    }
  },
  methods: {
    onEditRoom() {
      this.$emit("edit-room", this.currentRoom);
    },
    onCompleteCase() {
      this.$emit("complete-case", this.currentRoom);
    },
    onClickImage(chat) {
      const images = [
        ...this.conversations.filter(c => c.content_type === "img")
      ];
      const index = images.findIndex(i => i.id === chat.id);
      const imagesUrl = images.map(i => ({ url: i.content }));
      this.$emit("image", { images: imagesUrl, index });
    },
    onPickFile() {
      this.$refs.file.click();
    },
    onFilePicked(e) {
      this.readImage(e)
        .then(image => {
          let self = this;

          const data = new FormData();
          data.append("image", image.file);

          this.imageUploading = true;
          this.axios
            .post(`upload-image`, data, {
              cancelToken: new this.axios.CancelToken(function executor(c) {
                self.cancelUpload = c;
              })
            })
            .then(response => {
              const image = response.data.data;
              this.imageUploading = false;
              this.sendMessage({
                content: image.url,
                content_type: "img",
                media_id: image.id
              });
            })
            .catch(error => {
              this.imageUploading = false;
              if (this.axios.isCancel(error)) {
                this.$toasted.error(error.message, { icon: "mood_bad" });
              } else {
                this.saveErrorHandler(error);
              }
            });
        })
        .catch(e => {
          window.alert(e && e.message ? e.message : e);
        })
        .finally(() => {
          e.target.value = "";
        });
    },
    readImage({ target }) {
      const files = target.files;
      return new Promise((resolve, reject) => {
        if (!files || files.length === 0) {
          resolve();
          return;
        }
        const file = files[0];
        if (/^image\/\w+$/.test(file.type)) {
          if (URL) {
            resolve({
              loaded: true,
              name: file.name,
              type: file.type,
              url: URL.createObjectURL(file),
              file: file
            });
          } else {
            reject(new Error("Your browser is not supported."));
          }
        } else {
          reject(new Error("Please choose an image file."));
        }
      });
    },

    onClickOpenFileOrSheet() {
      this.$emit("open-file", this.currentRoom);
    },
    onChangeMessage(value) {
      this.$emit("update:message", value);
    },
    sendMessage(params) {
      if (this.messageSending) {
        return;
      }
      if (
        this.currentRoomId &&
        ((params.content_type === "msg" || params.content_type === "img") &&
          typeof params.content === "string" &&
          !isEmpty(trim(params.content)))
      ) {
        const currentRoomId = this.currentRoomId;
        this.messageSending = true;
        this.axios
          .post(`me/rooms/${currentRoomId}/send`, params, {
            headers: {
              "X-Socket-ID": isEmpty(this.socketId) ? "" : this.socketId
            }
          })
          .then(res => {
            const data = res.data.data;
            const newMessage = newMessageMapped(data);
            this.onChangeMessage("");
            this.$emit("new-message", {
              message: newMessage,
              roomId: currentRoomId
            });
          })
          .catch(error => {
            if ("message" in error) {
              this.$toasted.error(error.message, {
                icon: "mood_bad",
                className: "error"
              });
              return;
            }
            this.$toasted.error(this.$t("general.somethingWrong"), {
              icon: "mood_bad",
              className: "error"
            });
          })
          .finally(() => (this.messageSending = false));
      }
    },
    onKeyDown(e) {
      if (this.messageSending) {
        return;
      }
      if (e.keyCode === 13 && e.ctrlKey) {
        this.onChangeMessage(this.message + "\n");
        return;
      }
      if (e.keyCode === 13) {
        e.preventDefault();
        this.sendMessage({
          content: this.message,
          content_type: "msg",
          mention_ids: this.mentionIds
        });
      }
    },
    onClickSend() {
      this.sendMessage({
        content: this.message,
        content_type: "msg",
        mention_ids: this.mentionIds
      });
    },
    onMention() {
      this.$emit("mention");
    },
    parseContent(chat) {
      const users = this.$store.get("app/userEntities");
      let result = chat.content || "";
      let mentions = "";
      if (Array.isArray(chat.mentions) && chat.mentions.length > 0) {
        result += "</br><hr style='border-top: 1px dotted black'>";
        chat.mentions.forEach(m => {
          if (users[m]) {
            if (mentions !== "") mentions += ", ";
            mentions += users[m].name;
          }
        });
        if (mentions !== "") {
          mentions = "<small>" + mentions + "</small>";
        }
      }
      return result + mentions;
    }
  }
};
</script>

<style scoped lang="scss">
.chat-window {
  overflow-y: auto;
  /*height: calc(100vh - 65px - 60px - 108px);*/
  height: calc(100vh - 65px - 60px - 126px);
  border-radius: 0;
}

.chat-bubble {
  /*&::v-deep .v-timeline-item__body {*/
  /*    max-width: 100%;*/
  /*    max-width: 320px;*/
  /*}*/

  /*&::v-deep .v-timeline-item__divider {*/
  /*    min-width: 50px;*/
  /*}*/
  float: left;
}

.chat-bubble__card {
  border-radius: 10px;
  width: 100%;
  max-width: 480px;
  min-width: 200px;
}

.chat-bubble__right {
  float: right;
}

.v-timeline::before {
  background: transparent;
}
</style>
